import { ExpensesValueObjectsCreationTypeEnum } from 'generated/resources/graphql'

import Filter from 'modules/core/components/Filter'
import i18n from 'modules/core/lib/i18n'

interface ExpensesTypeFilterProps {
  selected?: ExpensesValueObjectsCreationTypeEnum
  setSelected: (value?: ExpensesValueObjectsCreationTypeEnum) => void
}

const ExpensesTypeFilter = ({ selected, setSelected }: ExpensesTypeFilterProps) => {
  return (
    <Filter.SingleChoice
      header={false}
      label={i18n.t('expenses_v2.reports.filters.expense_type.label')}
      options={[
        {
          label: i18n.t('expenses_v2.types.automatic'),
          value: 'automatic',
        },
        {
          label: i18n.t('expenses_v2.types.manual'),
          value: 'manual',
        },
      ]}
      value={selected}
      onValueChange={setSelected}
    />
  )
}

export default ExpensesTypeFilter
